import React from "react";
import Name from "okpay/components/fields/Name";
import ZipCode from "okpay/components/fields/ZipCode";
import CardNumber from "okpay/components/fields/CardNumber";
import SecurityCode from "okpay/components/fields/SecurityCode";
import Expiration from "okpay/components/fields/Expiration";
import Address from "okpay/components/fields/Address";
import PurchaseButton from "okpay/components/PurchaseButton";
import Str from "shared/components/Str";
import _str from "shared/util/_str";

import "./cardform.scss";

const CardForm = (props) => {
	let addressField;
	let billingError;
	let buttonText;

	if (props.showAddress) {
		addressField = (
			<Address
				hasSubmitted={props.hasSubmitted}
				value={props.address}
				error={props.addressError}
			/>
		);
	}

	// sometimes, the error will have HTML in it, and it's unavoidable.
	if (props.billingError && props.hasSubmitted) {
		const html = { __html: props.billingError };
		billingError = (
			<div className="okpay-cardform-error" dangerouslySetInnerHTML={html} />
		);
	}

	if (props.productId === "update") {
		buttonText = <Str>Update card</Str>;
	} else {
		buttonText = <Str>Confirm purchase</Str>;
	}

	return (
		<div className="okpay-cardform">
			<div className="okpay-cardform-header">
				<h1 className="okpay-cardform-heading">
					{_str("Enter your billing information")}
				</h1>
			</div>
			{billingError}
			<div className="okpay-cardform-fields">
				<Name
					isSubmitting={props.isSubmitting}
					hasSubmitted={props.hasSubmitted}
					value={props.name}
					error={props.nameError}
				/>
				<CardNumber
					cardType={props.cardType}
					isSubmitting={props.isSubmitting}
					hasSubmitted={props.hasSubmitted}
					value={props.cardNumber}
					error={props.cardNumberError}
				/>
				{addressField}
				<SecurityCode
					isSubmitting={props.isSubmitting}
					hasSubmitted={props.hasSubmitted}
					value={props.securityCode}
					error={props.securityCodeError}
				/>
				<Expiration
					isSubmitting={props.isSubmitting}
					hasSubmitted={props.hasSubmitted}
					value={props.expiration}
					error={props.expirationError}
				/>
				<ZipCode
					isSubmitting={props.isSubmitting}
					hasSubmitted={props.hasSubmitted}
					value={props.zipCode}
					error={props.zipCodeError}
					isUS={props.isUS}
				/>
			</div>
			<PurchaseButton
				rightSide={React.createElement(
					"div",
					{ className: "okpay-security" },
					<i className="okicon i-lock-closed" />,
					<Str>Secure</Str>,
				)}
			>
				{buttonText}
			</PurchaseButton>
		</div>
	);
};

export default CardForm;



// WEBPACK FOOTER //
// ./src/reflux/okpay/components/CardForm.jsx